import { menuItemClasses } from '@mui/material/MenuItem';
import type { Components, Theme } from '@mui/material/styles';

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: {
      '--MenuItem-background': 'var(--mui-palette-common-white)',
      '--MenuItem-borderRadius': '4px',
      '--MenuItem-paddingBlock': '8px',
      '--MenuItem-paddingInline': '8px',
      '--MenuItem-gap': '2px',

      '--MenuItem-hover-background': 'var(--mui-palette-neutral-50)',
      '--MenuItem-hover-color': 'var(--mui-palette-text-primary)',

      '--MenuItem-selected-background': 'var(--mui-palette-neutral-50)',
      '--MenuItem-selected-color': 'var(--mui-palette-text-primary)',

      backgroundColor: 'var(--MenuItem-background)',
      borderRadius: 'var(--MenuItem-borderRadius)',
      paddingBlock: 'var(--MenuItem-paddingBlock)',
      paddingInline: 'var(--MenuItem-paddingInline)',

      [`& + .${menuItemClasses.root}`]: {
        marginTop: 'var(--MenuItem-gap)',
      },

      [`&:not(.${menuItemClasses.selected}):hover`]: {
        backgroundColor: 'var(--MenuItem-hover-background)',
        color: 'var(--MenuItem-hover-color)',
      },

      [`&.${menuItemClasses.selected}`]: {
        backgroundColor: 'var(--MenuItem-selected-background)',
        color: 'var(--MenuItem-selected-color)',

        '&:hover': {
          backgroundColor: 'var(--MenuItem-selected-background)',
          color: 'var(--MenuItem-selected-color)',
        },
      },
    },
  },
};
